/**
 * Triggers display of webcomponent page creation notification pop up on login
 */
import infoDialogApi = require('diy/info-dialog/InfoDialogApi');
import websiteData = require('diy/util/websiteData');
import l10n = require('diy/util/l10n');
import $ = require('jquery');

    /**
     * triggers deactivation of success dialog per website feature deactivation on server
     */
    function disablePageCreationSuccessDialog(webComponentId: string, status: string) {
        $.ajax({
            url: '/app/cms/webcomponentpage/disable-notification',
            type: 'POST',
            dataType: 'json',
            headers: {
                'Accept': 'application/vnd.oneandone.diy.website.webcomponent-page-notification+json'
            },
            data: {
                webComponentId: webComponentId,
                status: status
            },
            error: function () {
                throw 'Could not disable the notification for success dialog on login';
            }
        });
    }

    /**
     * Display page creation success notification
     */
    export function showNotification(webComponentId: string) {
        setTimeout(function () {
            infoDialogApi.showDialog(
                {
                    title: l10n.getString('webComponentPageCreation.success.title.' + webComponentId),
                    description: getPageCreationDialogSuccessDescription(webComponentId),
                    image: websiteData.getCdnUrl() + 's/diy/site-admin/main/img/webcomponent-page-success.png',
                    imageHeight: 220,

                    secondaryButtonConfig: {
                        label: l10n.getString('webComponentPageCreation.success.closeButton'),
                        callback: function () {
                            $(document).trigger(
                                "diy-editor-generic-linkInteraction",
                                {
                                    pageName: "MyShopReady",
                                    actionName: "close"
                                }
                            );
                            disablePageCreationSuccessDialog(webComponentId, 'notification_rejected');
                        }
                    }
                }
            );
        }, 3000);

        $(document).trigger('diy-editor-generic-sectionAccessed', {'sectionCodeName': 'myShopReady'});
    }

    /**
     * Retrieves description of success dialog message to be displayed
     *
     * Note that if appserver API caller provided an externalSettingsLink,
     * this one will be appended to description too
     */
    function getPageCreationDialogSuccessDescription(webComponentId: string) {
        return l10n.getString('webComponentPageCreation.success.info.' + webComponentId);
    }



/** WEBPACK FOOTER **
 ** ./build/js/~/tslint-loader!./source/cdn/document_root/s/diy/app/webcomponentPageNotification.ts
 **/